module.exports = __webpack_public_path__ + "img/ddu-ddp.411075db.jpg";